// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: Kt5dshYubei
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SelectState from "../../SelectState"; // plasmic-import: EbL1EK3L-GE/component
import SelectGender2 from "../../SelectGender2"; // plasmic-import: GrmgjVgQJsy/component
import SelectBizClass from "../../SelectBizClass"; // plasmic-import: vWhk9cqiwZ0/component
import SelectBizClass__Option from "../../SelectBizClass__Option"; // plasmic-import: BmTOdnYKnWP/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingPersonalDetails.module.css"; // plasmic-import: Kt5dshYubei/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingPersonalDetails__VariantProps = new Array();

export const PlasmicOnboardingPersonalDetails__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingPersonalDetails__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "selectIndustry.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectGender.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "suite.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__zeK85)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__fTiCm
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__r4Oi3)}>
            <div className={classNames(projectcss.all, sty.freeBox___5Qp8O)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__a8G6Q)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___10Oip)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___0Inlk)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___0Pq3F)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__nJz6D)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__h4Rpe)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__l1GgF)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__ki0V)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__s4Jly
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__y9Mtb
                )}
              >
                {"Personal Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ttXq3
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__tdkU
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__zI5Ma)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__xjtOx
                )}
              >
                {
                  "Astrius collects this information to meet the requirements of our regulators and financial partners."
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__x2VhP)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox___3CLpE)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__bsYTx
                    )}
                  >
                    {"First Name"}
                  </div>
                  <input
                    data-plasmic-name={"firstName"}
                    data-plasmic-override={overrides.firstName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.firstName
                    )}
                    placeholder={"First"}
                    ref={ref => {
                      $refs["firstName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___5IYBb)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__qWdfB
                    )}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    data-plasmic-name={"lastName"}
                    data-plasmic-override={overrides.lastName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.lastName
                    )}
                    placeholder={"Last"}
                    ref={ref => {
                      $refs["lastName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />

                  <div
                    data-plasmic-name={"lastNameError"}
                    data-plasmic-override={overrides.lastNameError}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.lastNameError
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "small") ? (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Must complete all required fields"}
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Last Name is required field"}
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"firstNameError"}
                data-plasmic-override={overrides.firstNameError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.firstNameError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"First Name is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__xykzg)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0JgjW
                  )}
                >
                  {"Address"}
                </div>
                <input
                  data-plasmic-name={"textInput"}
                  data-plasmic-override={
                    overrides.textInput ?? overrides.textbox
                  }
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.textInput
                  )}
                  placeholder={"12-3456789"}
                  size={1}
                  type={"text"}
                  value={"United States"}
                />

                <div
                  data-plasmic-name={"countryError"}
                  data-plasmic-override={overrides.countryError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.countryError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Country is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <input
                  data-plasmic-name={"address1"}
                  data-plasmic-override={overrides.address1}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.address1
                  )}
                  placeholder={"Address Line"}
                  ref={ref => {
                    $refs["address1"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"addressError"}
                  data-plasmic-override={overrides.addressError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.addressError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Address is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <input
                  data-plasmic-name={"suite"}
                  data-plasmic-override={overrides.suite}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.suite
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["suite", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"Suite Number"}
                  ref={ref => {
                    $refs["suite"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["suite", "value"]) ?? ""
                  }
                />

                <input
                  data-plasmic-name={"city"}
                  data-plasmic-override={overrides.city}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.city
                  )}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["city"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"cityError"}
                  data-plasmic-override={overrides.cityError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.cityError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"City is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <SelectState
                  data-plasmic-name={"selectState"}
                  data-plasmic-override={overrides.selectState}
                  className={classNames("__wab_instance", sty.selectState)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "selectState",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  placeholder={"State"}
                  value={p.generateStateValueProp($state, [
                    "selectState",
                    "value"
                  ])}
                />

                <div
                  data-plasmic-name={"stateError"}
                  data-plasmic-override={overrides.stateError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.stateError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"State is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <input
                  data-plasmic-name={"zip"}
                  data-plasmic-override={overrides.zip}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.zip
                  )}
                  placeholder={"ZIP"}
                  ref={ref => {
                    $refs["zip"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"zipError"}
                  data-plasmic-override={overrides.zipError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.zipError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Zip Code is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__z5I80)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__uhut7
                  )}
                >
                  {"Date of Birth"}
                </div>
                <div
                  data-plasmic-name={"dob"}
                  data-plasmic-override={overrides.dob}
                  className={classNames(projectcss.all, sty.dob)}
                />

                <div
                  data-plasmic-name={"dateError"}
                  data-plasmic-override={overrides.dateError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.dateError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Date of Birth is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__ehohj)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__zWy2
                  )}
                >
                  {"Gender"}
                </div>
                <SelectGender2
                  data-plasmic-name={"selectGender"}
                  data-plasmic-override={overrides.selectGender}
                  className={classNames("__wab_instance", sty.selectGender)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "selectGender",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  value={p.generateStateValueProp($state, [
                    "selectGender",
                    "value"
                  ])}
                />

                <div
                  data-plasmic-name={"genderError"}
                  data-plasmic-override={overrides.genderError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.genderError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Gender is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__bufSs)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__yMpK
                  )}
                >
                  {"Social Security Number"}
                </div>
                <input
                  data-plasmic-name={"ssn"}
                  data-plasmic-override={overrides.ssn}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.ssn
                  )}
                  placeholder={"XXX-XX-XXXX"}
                  ref={ref => {
                    $refs["ssn"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <div
                  data-plasmic-name={"securityError"}
                  data-plasmic-override={overrides.securityError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.securityError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Social Security Number is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__qbwP3
                  )}
                >
                  {"Industry"}
                </div>
                <SelectBizClass
                  data-plasmic-name={"selectIndustry"}
                  data-plasmic-override={overrides.selectIndustry}
                  className={classNames("__wab_instance", sty.selectIndustry)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "selectIndustry",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  value={p.generateStateValueProp($state, [
                    "selectIndustry",
                    "value"
                  ])}
                >
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__hn3Q7)}
                    value={"9ed38146-7d6f-11e3-89d6-5404a6144203"}
                  >
                    {"Marketing"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__v0FLr)}
                    value={"9ed46b9e-7d6f-11e3-9fec-5404a6144203"}
                  >
                    {"Graphic Design"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option___5JwMw)}
                    textValue={""}
                    value={"9ed3a851-7d6f-11e3-92a4-5404a6144203"}
                  >
                    {"Software"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option___8Mwlh)}
                    textValue={""}
                    value={"9ed3cf60-7d6f-11e3-a80d-5404a6144203"}
                  >
                    {"Accounting"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__u5Pdw)}
                    value={"9ed3814f-7d6f-11e3-aaf6-5404a6144203"}
                  >
                    {"Wholesale"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__jqooF)}
                    value={"9ed3813d-7d6f-11e3-bd65-5404a6144203"}
                  >
                    {"Education"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__iEiL)}
                    value={"9ed3813c-7d6f-11e3-82cc-5404a6144203"}
                  >
                    {"Consulting"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__x8Qu4)}
                    value={"9ed3cf63-7d6f-11e3-b50c-5404a6144203"}
                  >
                    {"Investment Service"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option___1APm)}
                    value={"9ed46b95-7d6f-11e3-970b-5404a6144203"}
                  >
                    {"eCommerce Service"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__uBbtk)}
                    value={"9ed3a853-7d6f-11e3-a35d-5404a6144203"}
                  >
                    {"Web Hosting and Design"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option___4PiRd)}
                    value={"9ed4449a-7d6f-11e3-a380-5404a6144203"}
                  >
                    {"Retailer"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__vAw43)}
                    value={"9ed41d7a-7d6f-11e3-ae21-5404a6144203"}
                  >
                    {"Construction"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__v8Za)}
                    value={"9ed46ba6-7d6f-11e3-ae95-5404a6144203"}
                  >
                    {"Legal Services"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__aipni)}
                    value={"9ed35a38-7d6f-11e3-a24f-5404a6144203"}
                  >
                    {"Publishing"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__cHDwh)}
                    value={"9ed444a6-7d6f-11e3-ad1c-5404a6144203"}
                  >
                    {"Photography"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__qwTz)}
                    value={"9ed492a5-7d6f-11e3-8d8f-5404a6144203"}
                  >
                    {"Telecommunication Services"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__xlsJ0)}
                    value={"9ed4449f-7d6f-11e3-b867-5404a6144203"}
                  >
                    {"Public Relations"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__vc8T6)}
                    value={"9ed46ba3-7d6f-11e3-9efe-5404a6144203"}
                  >
                    {"Insurance"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option___4VBs3)}
                    value={"9ed492ab-7d6f-11e3-9907-5404a6144203"}
                  >
                    {"Real Estate"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__g5YwB)}
                    value={"9ed3814e-7d6f-11e3-9087-5404a6144203"}
                  >
                    {"Secretarial Support"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__hymfN)}
                    value={"9ed46b9a-7d6f-11e3-a11b-5404a6144203"}
                  >
                    {"Event Planning Support"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__tRbTb)}
                    value={"9ed4b9bb-7d6f-11e3-af9f-5404a6144203"}
                  >
                    {"Travel Agency"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__tDhCo)}
                    value={"9ed3f679-7d6f-11e3-a884-5404a6144203"}
                  >
                    {"Gifting"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__zaHzZ)}
                    value={"9ed38143-7d6f-11e3-bc00-5404a6144203"}
                  >
                    {"Recruiting Services"}
                  </SelectBizClass__Option>
                  <SelectBizClass__Option
                    className={classNames("__wab_instance", sty.option__rbkZp)}
                    value={"9ed3cf5a-7d6f-11e3-9a99-5404a6144203"}
                  >
                    {"Digital Media"}
                  </SelectBizClass__Option>
                </SelectBizClass>
                <div
                  data-plasmic-name={"industryError"}
                  data-plasmic-override={overrides.industryError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.industryError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Industry is required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__oXxiB)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__dxWni
                    )}
                  >
                    {"Phone Number"}
                  </div>
                  <input
                    data-plasmic-name={"phoneNumber"}
                    data-plasmic-override={overrides.phoneNumber}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.phoneNumber
                    )}
                    placeholder={""}
                    ref={ref => {
                      $refs["phoneNumber"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />

                  <div
                    data-plasmic-name={"phoneError"}
                    data-plasmic-override={overrides.phoneError}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.phoneError
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "small") ? (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Must complete all required fields"}
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Phone Number is required field"}
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox___86UK)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__lrfmv
                    )}
                  >
                    {"Website or Social Media Profile Link"}
                  </div>
                  <input
                    data-plasmic-name={"website"}
                    data-plasmic-override={overrides.website}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.website
                    )}
                    placeholder={""}
                    ref={ref => {
                      $refs["website"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />

                  <div
                    data-plasmic-name={"linkError"}
                    data-plasmic-override={overrides.linkError}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.linkError
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "small") ? (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Must complete all required fields"}
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FF0000" }}
                        >
                          {"Link is required field"}
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__p086O)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cFjSj
                    )}
                  >
                    {"Monthly credit card processing volume"}
                  </div>
                  <div
                    data-plasmic-name={"monthlyVolume"}
                    data-plasmic-override={overrides.monthlyVolume}
                    className={classNames(projectcss.all, sty.monthlyVolume)}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"volumeError"}
                data-plasmic-override={overrides.volumeError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.volumeError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Processing Volume is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__wazcn)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___27WC6
                  )}
                >
                  {"Average transaction size for credit card payments"}
                </div>
                <div
                  data-plasmic-name={"averageTicket"}
                  data-plasmic-override={overrides.averageTicket}
                  className={classNames(projectcss.all, sty.averageTicket)}
                />
              </div>
              <div
                data-plasmic-name={"averageTransactionError"}
                data-plasmic-override={overrides.averageTransactionError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.averageTransactionError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Average Transaction is required field"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__hzAW)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__djDDe
                  )}
                >
                  {
                    "Highest estimated transaction size for credit card payments"
                  }
                </div>
                <div
                  data-plasmic-name={"highestTicket"}
                  data-plasmic-override={overrides.highestTicket}
                  className={classNames(projectcss.all, sty.highestTicket)}
                />

                <div
                  data-plasmic-name={"highestEstimationerror"}
                  data-plasmic-override={overrides.highestEstimationerror}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.highestEstimationerror
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Highest Estimation Transaction field is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"ageError"}
                data-plasmic-override={overrides.ageError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.ageError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"You must be at least 18 years old to use our product"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"You must be at least 18 years old to use our product"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"ssnError"}
                data-plasmic-override={overrides.ssnError}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.ssnError
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {
                        "Individual must be at least 18 years old to pass certification"
                      }
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {
                        "Must provide all 9 digits of the social security number"
                      }
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__yaFkv
                  )}
                >
                  {"Continue"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "firstName",
    "lastName",
    "lastNameError",
    "firstNameError",
    "textInput",
    "textbox",
    "countryError",
    "address1",
    "addressError",
    "suite",
    "city",
    "cityError",
    "selectState",
    "stateError",
    "zip",
    "zipError",
    "dob",
    "dateError",
    "selectGender",
    "genderError",
    "ssn",
    "securityError",
    "selectIndustry",
    "industryError",
    "phoneNumber",
    "phoneError",
    "website",
    "linkError",
    "monthlyVolume",
    "volumeError",
    "averageTicket",
    "averageTransactionError",
    "highestTicket",
    "highestEstimationerror",
    "errorText",
    "ageError",
    "ssnError",
    "continueButton"
  ],

  lineStack: ["lineStack", "circle", "circle2", "circle3", "circle4"],
  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  firstName: ["firstName"],
  lastName: ["lastName"],
  lastNameError: ["lastNameError"],
  firstNameError: ["firstNameError"],
  textInput: ["textInput", "textbox"],
  countryError: ["countryError"],
  address1: ["address1"],
  addressError: ["addressError"],
  suite: ["suite"],
  city: ["city"],
  cityError: ["cityError"],
  selectState: ["selectState"],
  stateError: ["stateError"],
  zip: ["zip"],
  zipError: ["zipError"],
  dob: ["dob"],
  dateError: ["dateError"],
  selectGender: ["selectGender"],
  genderError: ["genderError"],
  ssn: ["ssn"],
  securityError: ["securityError"],
  selectIndustry: ["selectIndustry"],
  industryError: ["industryError"],
  phoneNumber: ["phoneNumber"],
  phoneError: ["phoneError"],
  website: ["website"],
  linkError: ["linkError"],
  monthlyVolume: ["monthlyVolume"],
  volumeError: ["volumeError"],
  averageTicket: ["averageTicket"],
  averageTransactionError: ["averageTransactionError"],
  highestTicket: ["highestTicket"],
  highestEstimationerror: ["highestEstimationerror"],
  errorText: ["errorText"],
  ageError: ["ageError"],
  ssnError: ["ssnError"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingPersonalDetails__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingPersonalDetails__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingPersonalDetails__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingPersonalDetails";
  } else {
    func.displayName = `PlasmicOnboardingPersonalDetails.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingPersonalDetails = Object.assign(
  // Top-level PlasmicOnboardingPersonalDetails renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    lastNameError: makeNodeComponent("lastNameError"),
    firstNameError: makeNodeComponent("firstNameError"),
    textInput: makeNodeComponent("textInput"),
    countryError: makeNodeComponent("countryError"),
    address1: makeNodeComponent("address1"),
    addressError: makeNodeComponent("addressError"),
    suite: makeNodeComponent("suite"),
    city: makeNodeComponent("city"),
    cityError: makeNodeComponent("cityError"),
    selectState: makeNodeComponent("selectState"),
    stateError: makeNodeComponent("stateError"),
    zip: makeNodeComponent("zip"),
    zipError: makeNodeComponent("zipError"),
    dob: makeNodeComponent("dob"),
    dateError: makeNodeComponent("dateError"),
    selectGender: makeNodeComponent("selectGender"),
    genderError: makeNodeComponent("genderError"),
    ssn: makeNodeComponent("ssn"),
    securityError: makeNodeComponent("securityError"),
    selectIndustry: makeNodeComponent("selectIndustry"),
    industryError: makeNodeComponent("industryError"),
    phoneNumber: makeNodeComponent("phoneNumber"),
    phoneError: makeNodeComponent("phoneError"),
    website: makeNodeComponent("website"),
    linkError: makeNodeComponent("linkError"),
    monthlyVolume: makeNodeComponent("monthlyVolume"),
    volumeError: makeNodeComponent("volumeError"),
    averageTicket: makeNodeComponent("averageTicket"),
    averageTransactionError: makeNodeComponent("averageTransactionError"),
    highestTicket: makeNodeComponent("highestTicket"),
    highestEstimationerror: makeNodeComponent("highestEstimationerror"),
    errorText: makeNodeComponent("errorText"),
    ageError: makeNodeComponent("ageError"),
    ssnError: makeNodeComponent("ssnError"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingPersonalDetails
    internalVariantProps: PlasmicOnboardingPersonalDetails__VariantProps,
    internalArgProps: PlasmicOnboardingPersonalDetails__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingPersonalDetails;
/* prettier-ignore-end */
